

(function fullPage(){
  if(!(theme.template.name == "index")) return;

  document.addEventListener('drawerOpen', () => {
    let fpNav = document.querySelector('#fp-nav')
    
    if(fpNav){
      fpNav.classList.add('hide');
    }
  })

  const fullPageOptions = {
    // Navigation
    menu: '#menu',
    lockAnchors: false,
    // anchors:['firstPage', 'secondPage'],
    navigation: false,
    navigationPosition: 'left',
    navigationTooltips: ['Home', 'New Arrivals', 'Best Sellers'],
    showActiveTooltip: true,
   
    // Scrolling
    css3: true,
    scrollingSpeed: 700,   
    easing: 'easeInOutCubic',  
      
    touchSensitivity: 15,   
    // Custom selectors
    sectionSelector: '.shopify-section',
    slideSelector: '.slide',
  
    lazyLoading: false,
    observer: true,
    credits: { enabled: true, label: 'Made with fullPage.js', position: 'right'},
    onLeave: function(origin, destination, direction, trigger){ 
  
      let selectors = {
        fpSectionOptions: "[id^='fp-section-options-']"
      }
  
      let fpSectionOptionsEl = destination.item.querySelector(selectors.fpSectionOptions);
      if(!fpSectionOptionsEl) return;
     
      let fpSectionOptions = JSON.parse(fpSectionOptionsEl.textContent); 
  
      let fpNav = document.querySelector('#fp-nav');
      if(fpNav){
        fpNav.style.setProperty('--fa-nav-color', `${fpSectionOptions.fpNavColor}`);
      }
    },
  
  }

  let myFullpage;
  if(window.innerWidth > 768){
    myFullpage = new fullpage('.template-index #MainContent', fullPageOptions);  
    // myFullpage.destroy('all');
  } 
  
  window.addEventListener('resize', (e)=>{
    if(window.innerWidth < 768){
      try{  myFullpage.destroy('all'); }
      catch (err){ console.log("FullPage Isn't initialized")  }
    }
    else{
      try{ myFullpage = new fullpage('#MainContent', fullPageOptions);}
      catch (err){console.log("Reniitiazliing FullPage")}
    }
  })
})();




(function quickAddToCart(){
  var selectors = {
    addToCartTrigger: '.js-quick-add-to-cart'
  }

  document.querySelectorAll(selectors.addToCartTrigger).forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      let variantID = btn.dataset.productId;
      window.ajaxAddToCart(variantID); 
    })
  }) 
})();